import React, { useEffect, useState } from 'react';
// import API from '@aws-amplify/api';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { assetsUrl, permissionsStatuses } from '../util/constants';
import { Form } from '../auth/authenticatorComponents/AuthenticatorForm';
import { Button } from '../components/Button';
import { ContentScreen } from '../styles/ContentScreen';

const mapStateToProps = ({ appData: { permissions } }) => {
   const subData = permissions?.subscriptionAndPurchases?.subscription;

   let isNotSubscribed = true;

   if (permissions.status === permissionsStatuses.loaded && subData) {
      if (
         new Date(subData.expiration) > Date.now() &&
         subData.includes.includes('exercise')
      ) {
         isNotSubscribed = false;
      }
   }

   return {
      isNotSubscribed,
   };
};

const Discord = connect(mapStateToProps)(({ isNotSubscribed }) => {
   const [discordInviteLink, setDiscordInviteLink] = useState(null);
   const [status, setStatus] = useState('pending');
   const [errorMessage, setErrorMessage] = useState(null);

   useEffect(() => {
      if (!isNotSubscribed) {
         fetch(`${assetsUrl}/secure/exercise/other/discord.json`, {
            credentials: 'include',
         })
            .then((res) => res.json())
            .then(({ inviteLink }) => setDiscordInviteLink(inviteLink));
      }
   });

   if (isNotSubscribed) {
      return (
         <ContentScreen className="narrower">
            <article>
               <h1>Join Discord</h1>
               <p>
                  You must have an active subscription to join the Ear
                  Instructor Discord.
               </p>

               <div style={{ textAlign: 'center' }}>
                  <Button
                     className="button-cta"
                     as={Link}
                     to="/app/account/subscribe"
                  >
                     Subscribe Now
                  </Button>
               </div>
            </article>
         </ContentScreen>
      );
   }

   if (status === 'success') {
      return (
         <ContentScreen className="narrower">
            <article>
               <h1>Join Discord</h1>
               <h2>Success!</h2>
               <p>
                  You have connected your Discord account and now have access to
                  the server.
               </p>
               <div style={{ textAlign: 'center' }}>
                  <Button className="button-cta" as={Link} to="/app/dashboard">
                     Back to Dashboard
                  </Button>
               </div>
            </article>
         </ContentScreen>
      );
   }
   return (
      <ContentScreen className="narrower">
         <article>
            <h1>Join Discord</h1>
            <h2>Invite Link</h2>
            <p>
               <a
                  href={discordInviteLink}
                  target="_blank"
                  rel="noreferrer noopener"
                  className="link"
               >
                  {discordInviteLink}
               </a>
            </p>
            <h2>Connect Your Account</h2>

            <Form
               className="selectable"
               style={{ marginTop: '2em' }}
               onSubmit={(e) => {
                  e.preventDefault();
                  const data = new FormData(e.target);

                  setStatus('loading');
                  setErrorMessage(null);

                  // API.post('app', '/discord/connect', {
                  //    body: {
                  //       nickname: data.get('nickname'),
                  //       tag: data.get('tag'),
                  //    },
                  // })
                  //    .then(() => {
                  //       setStatus('success');
                  //    })
                  //    .catch((err) => {
                  //       setStatus('pending');
                  //       if (err.message === 'Network Error') {
                  //          setErrorMessage('Network Error.');
                  //       } else {
                  //          switch (err?.response?.data?.error) {
                  //             case 'DiscordUserNotFound': {
                  //                setErrorMessage(
                  //                   'Discord user not found. Double check your nickname and tag and make sure you are currently logged in on the server.'
                  //                );
                  //                break;
                  //             }
                  //             case 'DiscordAlreadyConnected': {
                  //                setErrorMessage(
                  //                   'You have already connected your Discord account. If your roles were not updated on Discord, please contact Ear Instructor support.'
                  //                );
                  //                break;
                  //             }
                  //             case 'SubscriptionNotActiveError': {
                  //                setErrorMessage(
                  //                   'You have canceled your subscription to Ear Instructor. An active subscription is required to connect your Discord account.'
                  //                );
                  //                break;
                  //             }
                  //             default: {
                  //                setErrorMessage(
                  //                   'An unexpected error occurred. Please try again later.'
                  //                );
                  //             }
                  //          }
                  //       }
                  //    });
               }}
            >
               {errorMessage && <p className="error-message">{errorMessage}</p>}
               <input
                  name="nickname"
                  placeholder="Nickname"
                  required
                  maxLength="50"
                  disabled={status === 'loading'}
               />
               <input
                  name="tag"
                  placeholder="Tag"
                  required
                  maxLength="50"
                  disabled={status === 'loading'}
               />
               <Button
                  className={classNames('button-cta', {
                     'button-loading': status === 'loading',
                  })}
                  type="submit"
                  disabled={status === 'loading'}
               >
                  Connect
               </Button>
            </Form>
         </article>
      </ContentScreen>
   );
});

export { Discord };
